import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import ApiRequest from "../../../helper/ApiRequest";
import CustomSelect from "../../../component/CustomSelect";
import DynamicCKEditor from "../../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const addJobEndpoint = ApiEndpoints.job.create;
const locationListEndpoint = ApiEndpoints.location.list;
const departmentListEndpoint = ApiEndpoints.department.list;

export default function AddJob() {
  const navigate = useNavigate();

  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);

  const [postData, setPostData] = useState({ title: "", slug: "", department_id: "", location_id: "", date: new Date(), brief_description: "", job_description: "", roles_and_responsibilities: "", candidate_profile: "", skills: "", perks_and_benefit:"", about_nativeSutra: "", qualification: "", openpost: "0", });

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await ApiRequest("GET", departmentListEndpoint);
        setDepartments(response?.departments || []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setDepartments([]);
      }
    };

    const fetchLocations = async () => {
      try {
        const response = await ApiRequest("GET", locationListEndpoint);
        setLocations(response?.locations || []);
      } catch (error) {
        console.error("Failed to fetch authors:", error);
        setLocations([]);
      }
    };

    fetchDepartments();
    fetchLocations();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPostData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  const requiredFields = [
    "title",
    "slug",
    "department_id",
    "location_id",
    "date",
    "brief_description",
  ];


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const field of requiredFields) {
      if (!postData[field] || postData[field].toString().trim() === "") {
        toast.error(`The field "${field.replace(/_/g, " ")}" is mandatory.`);
        return;
      }
    }

    try {
      const response = await ApiRequest("POST", addJobEndpoint, postData);
      if (response?.error === false) {
        toast.success(response?.message);
        navigate("/job");
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };


  const handleCheckboxChange = (e) => {
    setPostData((prev) => ({
      ...prev,
      openpost: e.target.checked ? "1" : "0",
    }));
  };


  const pagename = {
    name: 'Career Management',
    user: 'Admin',
    innerpage: 'Career Management / Jobs / Add Job'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="jobAdd" onSubmit={handleSubmit}>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <label className="coustom-checkbox">
                    <input type="checkbox" checked={postData.openpost === "1"} onChange={handleCheckboxChange}/>{" "} <span className="checkmark"></span>Show Job Post
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input value={postData?.title} onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input value={postData?.slug} onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="date" type="date" className="form-control" placeholder="Enter Author Name" />
                </div>
              </div>

              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Job Type<small>*</small></label>
                  </div>
                  <input value={postData?.type} onChange={handleChange} name="type" type="text" className="form-control" placeholder="Enter Job Type" />
                </div>
              </div> */}

              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Working Days<small>*</small></label>
                  </div>
                  <input value={postData?.working_day} onChange={handleChange} name="working_day" type="text" className="form-control" placeholder="Ex: monday to friday" />
                </div>
              </div> */}

              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Shift<small>*</small></label>
                  </div>
                  <input value={postData?.shift} onChange={handleChange} name="shift" type="text" className="form-control" placeholder="Ex: Day / Night" />
                </div>
              </div> */}

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Location<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"location_id"} options={locations} placeholder="Select Location" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Department<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="department_id" options={departments} placeholder="Select Department" />
                </div>
              </div>

            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Brief Description<small>*</small></label>
                  </div>
                  <input value={postData.brief_description} onChange={handleChange} name="brief_description" type="text" className="form-control" placeholder="Short Description" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Job Description</label>
                  </div>
                  <DynamicCKEditor data={postData.job_description} onChange={(event) => handleEditorChange("job_description", event?.editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Roles and Responsibilities</label>
                  </div>
                  <DynamicCKEditor data={postData.roles_and_responsibilities} onChange={(event) => handleEditorChange("roles_and_responsibilities", event?.editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Desired Candidate Profile</label>
                  </div>
                  <DynamicCKEditor data={postData.candidate_profile} onChange={(event) => handleEditorChange("candidate_profile", event?.editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Qualification</label>
                  </div>
                  <DynamicCKEditor data={postData.qualification} onChange={(event) => handleEditorChange("qualification", event?.editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Required Skills</label>
                  </div>
                  <DynamicCKEditor data={postData.skills} onChange={(event) => handleEditorChange("skills", event?.editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Perks and Benefits</label>
                  </div>
                  <DynamicCKEditor data={postData.perks_and_benefit} onChange={(event) => handleEditorChange("perks_and_benefit", event?.editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>About NativeSutra</label>
                  </div>
                  <DynamicCKEditor data={postData.about_nativeSutra} onChange={(event) => handleEditorChange("about_nativeSutra", event?.editor?.getData())} />
                </div>
              </div>

            </div>
          </div>

        </form>
        <button type="submit" form="jobAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
